import React, { useEffect, useState } from 'react';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import {
  Box,
  HStack,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react';

import { Empty } from 'antd';
import UserAvatar from 'components/userAvatar';
import LogWork from './LogWork';

const HistoryWorklog = (props) => {
 
 
  const [workdata, setWorkdata] = useState([]);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
const [selectedDeleteLog, setSelectedDeleteLog] = useState(null);
const { id: projectId } = useParams();


  const project_id = props?.taskdata?.project_id || projectId;

let work_id;

if (props.work_type === "SUBTASK") {
  work_id = props?.taskdata?.subtask_id;
} else if (props.work_type === "EPIC") {
  work_id = props?.taskdata?.epic_id;
} else {
  work_id = props?.taskdata?.issue_id;
}

const work_type = props.work_type || "ISSUE";



  useEffect(() => {
    if (project_id && work_id) {
      getHistoricalWorkLogs();
    }
  }, [project_id, work_id, props.refreshKey]);

  

 
  const getHistoricalWorkLogs = async () => {
    const queryparams = `?project_id=${project_id}&work_id=${work_id}&work_type=${work_type}`;
    try {
      const response =
        await httpInjectorService.getHistoricalWorkLogs(queryparams);

      if (response?.status === 'success') {
        setWorkdata(response.data || []);
      } else {
        setWorkdata([]);
      }
    } catch (error) {
      console.error(error);
      setWorkdata([]);
    }
  };

  const handleDeleteClick = (log) => {
  setSelectedDeleteLog(log);
  setIsDeleteOpen(true);
};
const handleConfirmDelete = async () => {
  if (!selectedDeleteLog) return;

  try {
    const payload = {
      log_id: selectedDeleteLog.log_id,
      work_id: work_id,
      work_type: work_type,
      project_id:project_id,
    };
   

    const response = await httpInjectorService.deleteLoggedTime(payload);

    if (response?.status === 'success') {
      setIsDeleteOpen(false);
      setSelectedDeleteLog(null);
      getHistoricalWorkLogs(); // refresh list
    }
  } catch (error) {
    console.error(error);
  }
};


  const handleEditClick = (log) => {
    setSelectedLog(log);
    setIsEditOpen(true);
  };

  return (
    <>
      <Box>
        {workdata.length > 0 ? (
          workdata.map((log) => (
            <Box
              key={log.log_id}
              // bg="#f4f5f7"
              px={2}
              py={1}
              mb={2}
              borderRadius="4px"
            >
              <HStack align="start" spacing={2}>
                <UserAvatar username={log.username || 'Unknown'} size={28} />

                <Box flex="1" lineHeight="1.2">
                  {/* Top line */}

                  {/* Top line */}
                  <Text fontSize="sm" m="0">
                    <Text as="span" fontWeight="600">
                      {log.username || 'Unknown'}
                    </Text>{' '}
                    logged {log.duration_input}
                    {log.expired === 1 && (
                      <Text as="span" fontSize="xs" color="red.500" ml={2}>
                        (Expired)
                      </Text>
                    )}
                  </Text>

                  {/* Date */}
                  <Text fontSize="xs" color="gray.500" m="0">
                    {new Date(log.start_time_epoch * 1000).toLocaleString(
                      undefined,
                      {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: '2-digit',
                        hour12: true,
                      },
                    )}
                  </Text>

                  {/* Description */}
                  {log.description && (
                    <Box
                      fontSize="sm"
                      // color="gray.800"
                      m="1"
                      dangerouslySetInnerHTML={{
                        __html: log.description,
                      }}
                    />
                  )}

                  {/* Actions */}
                  {/* Actions */}
                  {log.expired !== 1 && (
                    <Text fontSize="sm" color="gray.700" m="0">
                      <Text
                        as="span"
                        cursor="pointer"
                        _hover={{ textDecoration: 'underline' }}
                        onClick={() => handleEditClick(log)}
                      >
                        Edit
                      </Text>

                      {' · '}
                     <Text
  as="span"
  cursor="pointer"
  _hover={{ textDecoration: 'underline' }}
  onClick={() => handleDeleteClick(log)}
>
  Delete
</Text>

                    </Text>
                  )}
                </Box>
              </HStack>
            </Box>
          ))
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No work logs found"
          />
        )}
      </Box>
      <LogWork
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        work_Id={work_id}
        work_Type="ISSUE"
        taskDetails={props.taskdata}
        editData={selectedLog}
        getHistoricalWorkLogs={getHistoricalWorkLogs}
        showMenu={false}
      />
      <Modal
  isOpen={isDeleteOpen}
  onClose={() => setIsDeleteOpen(false)}
  isCentered
>
  <ModalOverlay />
  <ModalContent>
    <ModalHeader>Delete Work Log</ModalHeader>
    <ModalCloseButton />

    <ModalBody>
      {selectedDeleteLog && (
        <>
          <Text mb={3}>
            Are you sure you want to delete this logged time?
          </Text>

          <Box
            borderWidth="1px"
            borderRadius="md"
            p={3}
            bg="gray.50"
          >
            {/* Username */}
            <Text fontWeight="600">
              {selectedDeleteLog.username || 'Unknown'}
            </Text>

            {/* Duration */}
            <Text fontSize="sm" mt={1}>
              <strong>Logged Time:</strong> {selectedDeleteLog.duration_input}
            </Text>

            {/* Start Time */}
            <Text fontSize="sm" mt={1}>
              <strong>Date:</strong>{' '}
              {new Date(
                selectedDeleteLog.start_time_epoch * 1000
              ).toLocaleString(undefined, {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
              })}
            </Text>

            {/* Description */}
            {selectedDeleteLog.description && (
              <Box mt={2}>
                <Text fontSize="sm" fontWeight="500">
                  Description:
                </Text>
                <Box
                  fontSize="sm"
                  mt={1}
                  dangerouslySetInnerHTML={{
                    __html: selectedDeleteLog.description,
                  }}
                />
              </Box>
            )}
          </Box>
        </>
      )}
    </ModalBody>

    <ModalFooter>
      <Button mr={3} onClick={() => setIsDeleteOpen(false)}>
        Cancel
      </Button>
      <Button colorScheme="red" onClick={handleConfirmDelete}>
        Yes, Delete
      </Button>
    </ModalFooter>
  </ModalContent>
</Modal>

    </>
  );
};

export default HistoryWorklog;
